import {BaseCommand} from './base.command';
import {OverlayElementSnapshot} from '../interfaces/command.interface';
import {OverlayElementApiService} from '../../../api/services/overlay-element.service';
import {OverlayElementManagerService} from '../../overlay-element-manager.service';
import {firstValueFrom} from 'rxjs';

export class CreateOverlayElementCommand extends BaseCommand<OverlayElementSnapshot> {
  constructor(
    private overlayService: OverlayElementApiService,
    private overlayManager: OverlayElementManagerService,
    snapshot: OverlayElementSnapshot
  ) {
    super(
      'create-overlay-element',
      'Overlay Creation',
      {
        before: {element: {} as any},
        after: snapshot
      },
      {object: 'Overlay', verb: 'Creation'}
    );
  }

  async execute(): Promise<void> {
    const element = this.snapshot.after.element;
    if (!element?.id) return;

    await firstValueFrom(this.overlayService.restore(element.id));
    this.overlayManager.addElement(element);
  }

  async undo(): Promise<void> {
    const element = this.snapshot.after.element;
    if (!element?.id) return;

    await firstValueFrom(this.overlayService.delete(element.id));
    this.overlayManager.removeElement(element.id);
  }
}
